"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTypes = exports.ShapeTypes = void 0;
class ShapeTypes {
    static RECTANGLE = "RECTANGLE";
    static POINT = "POINT";
    static ELLIPSE = "ELLIPSE";
    static ROUNDED_RECTANGLE = "ROUNDED_RECTANGLE";
    static LINE = "LINE";
    static BCURVE = "BCURVE";
    static ARC = "ARC";
    static PATH = "PATH";
}
exports.ShapeTypes = ShapeTypes;
class ActionTypes {
    static ACTION_MOVE_TO = 0;
    static ACTION_LINE_TO = 1;
    static ACTION_CURVE_TO = 2; //cubic bezier cirve
    static ACTION_QUAD_TO = 3; //quadratic bezier curve
    static ACTION_ARC_TO = 4;
    static ACTION_ARC = 5;
    static ACTION_DASHED_LINE_TO = 6;
}
exports.ActionTypes = ActionTypes;
//# sourceMappingURL=types.js.map